<script setup lang="ts">
const { getResourceUrl } = useResources()

const { renderVueForStaticContent } = useRuntimeConfig().public
</script>

<template>
  <ContentBlock
    v-if="!renderVueForStaticContent"
    content-code="contact-us"
    render-whole-section
  />
  <section v-else class="mb-32 bg-neutral-50 py-16">
    <div class="container">
      <div class="flex flex-wrap">
        <div class="mx-auto max-w-4xl">
          <div class="flex flex-wrap">
            <div class="w-full md:w-[58%]">
              <div class="py-8 pr-16">
                <h2
                  class="mb-6 text-[calc(1.375rem+1.5vw)] font-bold leading-[1] lg:text-4xl"
                >
                  {{ $t('base.contactUs.title.top') }}
                  <br />
                  {{ $t('base.contactUs.title.middle') }}
                  <template v-if="$te('base.contactUs.title.last')">
                    <br />
                    {{ $t('base.contactUs.title.last') }}
                  </template>
                </h2>
                <p class="text-sm">
                  {{ $t('base.contactUs.description') }}
                </p>
              </div>
            </div>
            <div class="w-full md:w-[42%]">
              <div class="-mb-40 lg:-mr-16 lg:-mt-8">
                <figure class="relative m-0 overflow-hidden">
                  <div
                    class="relative block w-full overflow-hidden bg-neutral-50 p-0 opacity-50 before:block before:pt-[100%] before:content-['']"
                  >
                    <img
                      :src="getResourceUrl('/file/nodes/web-kontak-zidle.jpg')"
                      alt=""
                      class="absolute bottom-0 left-0 top-0 h-full w-full border-0 object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div
                    class="absolute left-0 top-0 flex h-full w-full flex-col justify-end p-8 text-black before:block"
                  >
                    <h3
                      class="text-[calc(1.275rem+.3vw)] font-bold lg:text-2xl"
                    >
                      {{ $t('base.contactUs.action') }}
                    </h3>
                    <address>
                      <NuxtLink
                        :to="'tel:' + $t('baseCommon.contactUs.firstNumber')"
                        class="text-nowrap no-underline"
                      >
                        {{ $t('baseCommon.contactUs.firstNumber') }}
                      </NuxtLink>
                      <br />
                      <NuxtLink
                        :to="'tel:' + $t('baseCommon.contactUs.secondNumber')"
                        class="text-nowrap no-underline"
                      >
                        {{ $t('baseCommon.contactUs.secondNumber') }}
                      </NuxtLink>
                      <br />
                      <NuxtLink
                        :to="'mailto:' + $t('baseCommon.contactUs.email')"
                        class="inline-block cursor-pointer select-auto text-nowrap border-b border-black py-0 no-underline"
                      >
                        {{ $t('baseCommon.contactUs.email') }}
                      </NuxtLink>
                    </address>
                  </div>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
